<template>
  <div class="arrival">
    <div class="heading-3-bold popup-title" v-html="popup.sections.main.fields.value.title"></div>
    <div class="lead-1 popup-subtitle" v-html="popup.sections.main.fields.value.subTitle"></div>
    <div class="paragraph-1" v-html="popup.sections.main.fields.value.text"></div>
    <div class="button-wrapper">
      <seu-button
        :label="popup.sections.main.fields.value.buttonLabel"
        :button-icon-before="share"
        :button-link="popup.sections.main.fields.value.buttonLink"
        target="_blank"
      />
    </div>
  </div>
</template>

<script>
import SeuButton from "/seu-frontend/components/SeuButton";
export default {
  name: "Arrival.vue",
  components: {SeuButton},
  data:()=>({
    share: require('../../assets/icons/share-white.svg'),
  }),
  computed: {
    popup() {
      return require(`../../services/pages/${this.$store.state.currentLanguage.toLowerCase()}/directions`).default;
    }
  },
}

</script>

<style lang="scss">
@import "../../css/style/breakpoints";
.arrival {
  padding-right: 34px;

  .button-wrapper{
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 0;
    transform: translateY(50%);
  }

  @include mq($until: mobile) {
    padding-right: 18px;

    .button-wrapper {
      bottom: auto;
      padding: 0 32px;
    }
  }
}
</style>
